import { gql } from '@apollo/client';
import USER_FRAGMENT from '../fragments/user';

export default gql`
  mutation TransferUserToLine($input: TransferUserToLineInput!) {
    transferUserToLine(input: $input) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;
